import { ApiError } from '../api/envelope';
import { useTranslate } from '../i18n/useTranslate';

/**
 * Hata görünümü. Hata KODUNU ve İSTEK KİMLİĞİNİ gösterir (SEOAI-78 kabul
 * kriteri): kullanıcı destek talebinde bu kimliği verdiğinde sunucudaki log
 * kaydı ve Sentry olayı tek sorguyla bulunur (SEOAI-43/17/74).
 */
export function ErrorView({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const t = useTranslate();
  const apiError = error instanceof ApiError ? error : null;

  return (
    <div role="alert" className="error">
      <h2>{t('error.title')}</h2>
      <p>{apiError?.message ?? String(error)}</p>

      {apiError && (
        <dl className="error-meta">
          <dt>{t('error.code')}</dt>
          <dd><code>{apiError.code}</code></dd>

          {apiError.requestId && (
            <>
              <dt>{t('error.requestId')}</dt>
              <dd><code>{apiError.requestId}</code></dd>
            </>
          )}
        </dl>
      )}

      {onRetry && (
        <button type="button" onClick={onRetry}>
          {t('error.retry')}
        </button>
      )}
    </div>
  );
}
